import React from 'react'

interface RangePresetButtonProps {
  label: string
  onClick: () => void
  isActive?: boolean
  className?: string
}

const RangePresetButton: React.FC<RangePresetButtonProps> = ({
  label,
  onClick,
  isActive = false,
  className = '',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        w-full px-3 py-2 text-left text-sm font-medium rounded-lg transition-all
        font-['IBM Plex Sans Arabic']
        ${isActive 
          ? 'bg-flutter-button text-white' 
          : 'text-gray-700 hover:bg-gray-100 hover:text-flutter-button'
        }
        ${className}
      `}
    >
      {label}
    </button>
  )
}

export default RangePresetButton

